module.exports = "<div class=\"user-container\">\n    <span>{{username}}</span>\n    <button kendoButton type=\"button\" [primary]=\"true\" (click)=\"logout()\">{{'LOGOUT' | translate}}</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/header/header.component.html
// module id = ./src/app/modules/shared/header/header.component.html
// module chunks = main